module.exports = __webpack_public_path__ + "img/file-lock-01.724a327c.svg";